import { createGlobalStyle, css } from 'styled-components';

import cssReset from './styled/cssReset';

const globalStyle = css`
  ${cssReset};

  html,
  body,
  #root {
    height: 100%;
  }

  body {
    color: ${({ theme }) => theme.colors.night};
    overflow-y: overlay;
    line-height: 1.3;
  }
`;

export default createGlobalStyle`${globalStyle}`;
